import React, { useState, useEffect } from "react"

import Layout from "components/Layout"
import toastHandler from "toastHandler"

import { getControlesCartera, getEmpresasCartera } from "api"

import MonitoreoPanel from "./MonitoreoPanel"
import "../OnBoarding/onboarding-theme.css"

// Datos de ejemplo para desarrollo (cuando la API no está disponible)
const EMPRESAS_EJEMPLO = [
  { id: 1, cuit: "30712345678", razonSocial: "ACME S.A." },
  { id: 2, cuit: "30787654321", razonSocial: "Industrias XYZ S.R.L." },
  { id: 3, cuit: "30711111111", razonSocial: "Comercial ABC S.A." },
]

const generarControlesEjemplo = () => {
  const hoy = new Date()
  const controles = []

  const tiposControl = [
    {
      id: "kyc_rescreening",
      nombre: "Re-screening KYC/AML",
      categoria: "compliance",
    },
    {
      id: "bcra_check",
      nombre: "Consulta Central BCRA",
      categoria: "financiero",
    },
    { id: "repet_check", nombre: "Consulta RePET", categoria: "compliance" },
    {
      id: "scoring_recalc",
      nombre: "Recálculo Scoring",
      categoria: "financiero",
    },
    {
      id: "eeff_update",
      nombre: "Actualización EEFF",
      categoria: "financiero",
    },
    {
      id: "covenants_check",
      nombre: "Verificación Covenants",
      categoria: "financiero",
    },
    {
      id: "poderes_vigencia",
      nombre: "Vigencia de Poderes",
      categoria: "legal",
    },
    {
      id: "avaluo_garantia",
      nombre: "Avalúo de Garantías",
      categoria: "garantias",
    },
  ]

  EMPRESAS_EJEMPLO.forEach((empresa, empIdx) => {
    tiposControl.forEach((tipo, tipoIdx) => {
      const diasOffset = Math.floor(Math.random() * 120) - 30
      const proximaFecha = new Date(hoy)
      proximaFecha.setDate(proximaFecha.getDate() + diasOffset)

      const ultimaEjecucion = new Date(hoy)
      ultimaEjecucion.setDate(ultimaEjecucion.getDate() - (90 - diasOffset))

      let estado = "vigente"
      if (diasOffset < 0) estado = "vencido"
      else if (diasOffset <= 15) estado = "por_vencer"
      else if (diasOffset <= 30) estado = "proximo"

      const resultados = ["ok", "ok", "ok", "observado", "deterioro"]
      const ultimoResultado =
        resultados[Math.floor(Math.random() * resultados.length)]

      controles.push({
        id: empIdx * 100 + tipoIdx + 1,
        empresaId: empresa.id,
        empresaNombre: empresa.razonSocial,
        tipoControlId: tipo.id,
        nombre: tipo.nombre,
        categoria: tipo.categoria,
        nivelRiesgo: ["BAJO", "MEDIO", "ALTO"][Math.floor(Math.random() * 3)],
        estado,
        ultimaEjecucion: ultimaEjecucion.toLocaleDateString("es-AR"),
        proximaFecha: proximaFecha.toLocaleDateString("es-AR"),
        diasParaVencer: diasOffset,
        ultimoResultado: estado !== "vencido" ? ultimoResultado : null,
        historial: [],
      })
    })
  })

  return controles
}

const index = ({ permissionBy }) => {
  const [empresas, setEmpresas] = useState([])
  const [controles, setControles] = useState([])
  const [loading, setLoading] = useState(false)

  // Cargar datos al montar
  useEffect(() => {
    cargarDatos()
  }, [])

  const cargarDatos = async () => {
    setLoading(true)

    try {
      const [empresasData, controlesData] = await Promise.all([
        getEmpresasCartera(),
        getControlesCartera(),
      ])
      setEmpresas(empresasData)
      setControles(controlesData)
    } catch (err) {
      console.warn(
        "No se pudo conectar con la API, usando datos de ejemplo:",
        err.message,
      )
      setEmpresas(EMPRESAS_EJEMPLO)
      setControles(generarControlesEjemplo())
    } finally {
      setLoading(false)
    }
  }

  const handleSetControles = newControles => {
    if (typeof newControles === "function") {
      setControles(prev => newControles(prev))
    } else {
      setControles(newControles)
    }
  }

  const props = {
    empresas,
    controles,
    setControles: handleSetControles,
  }

  const components = [
    {
      component: <MonitoreoPanel {...props} />,
    },
  ]

  return (
    <Layout
      components={components}
      title="Monitoreo de Cartera"
      loading={loading}
      permissionBy={permissionBy}
    />
  )
}

export default index
